// 验证手机号
export const RegPhone = new RegExp(/^1[3456789]\d{9}$/, 'g')
// 验证短信验证码
export const RegSendNumber = new RegExp(/^\d{4}$/, 'g')
// 验证邮箱
export const RegEmail = new RegExp(/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/, 'g')
// 验证6-20的数字大小写字母组成的密码
export const RegPassword = new RegExp(/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])^.{6,20}$/, 'g')
export const RegPasswordText = '请输入大小写字母+数字组合，6-20位的密码'
// 验证用户名
export const RegUserAccount = new RegExp(/^[A-Za-z]+$/g, 'g')
